<template>
<div class="container">
  <br><br><br>
  <BuyerInfo ref="buyerInfoRef"
        @onClose="handleBIOnClose"
  />
  <br>
  <!-- <div class="card bg-light">
    <div class="card-body"> -->
      <!-- @onToggleOpen="handleToggleOpen" -->
      <Chat ref="chatRef"
        iconColorProp="#e6e6e6"
        messageOutColorProp="#4d9e93"
        messageInColorProp="#f1f0f0"
        messageBackgroundColorProp="#ffffff"
        :messageListProp="messageList"
        :initOpenProp="initOpen"
        :newMessagesProp="newMessages"
        @onMessageWasSent="handleMessageSent"
      />
      <br>
    <!-- </div>
  </div> -->

  <div align="center">
    <label for="loadingMsg" v-if="loading">{{loadingMsg}}</label>
    <scale-loader :loading="loading"></scale-loader>
  </div>



</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapActions } from 'vuex';
import Chat from './common/Chat.vue'
// import axios from 'axios'
import ScaleLoader from './common/ScaleLoader'
import { DB } from '../config/firebaseConfig'
import { collection, query, where, orderBy, onSnapshot } from "firebase/firestore"
import { anonSignIn, getNotificationToken } from '../config/firebaseConfig.js';
import axios from "axios"
import BuyerInfo from './common/BuyerInfo.vue'

export default {
  name: 'Messages',

  components: {
    Chat,
    ScaleLoader,
    BuyerInfo
  },

  created() {
  },

  mounted(){
    this.getCustomerMessages()
  },

  data() {
    return {
      messageList: [],
      initOpen: true,
      toggledOpen: false,
      newMessages: false,
      currentMessage: '',

      loading: false,
      loadingMsg: null,
    }
  },

  computed: {
    ...mapGetters(['items1', 'items2', 'itemLevel', 'orgId', 'orgName', 'buyer', 'isLoggedIn', 'currentUser']),
  },

  methods: {
    ...mapActions(['setItemLevel', 'setOrgId', 'authStatusChange', 'addMessage', 'setBuyer']),

      //Get customer messages from db
      async getCustomerMessages(){
        var self = this

        const tokens = await anonSignIn()
        if (tokens.auth == ''){
          self.addMessage({messageClass: 'error', message: "Invalid User",})
          return
        } else {
          self.authStatusChange()
        }

        // const querySnapshot = await getDocs(q)
        // await querySnapshot.forEach((doc) => {
        //   self.messageList.push({'text': doc.data().text, 'source': doc.data().source})
        // })
        // console.log(self.messageList.length)
        // self.$refs.chatRef.messageScroll()

        const q = query(collection(DB, "Org", self.orgId, "Messages"), 
                        where("userId", "==", self.currentUser.uid), 
                        orderBy("created"));

        onSnapshot(q, (querySnapshot) => {
          self.messageList = []
          querySnapshot.forEach((doc) => {
            self.messageList.push({'text': doc.data().text, 'source': doc.data().source})
          });
          if (self.messageList.length == 0){
            self.messageList.push({'text': 'Welcome to Business Messaging.', 'source': 'B'})
          }
          self.newMessages = !self.newMessages
        });

      },

      // Send message from customer
      handleMessageSent(message) {
        var self = this

        self.currentMessage = message

        if (!self.buyer.name || self.buyer.name=='undefined'){
          self.buyer.name = ""
        }
        
        if (!self.buyer.phone || self.buyer.phone=='undefined')
          self.buyer.phone = ""

        // Check if buyer name and phone is specified.
        if (self.buyer.name == '' ||  self.buyer.phone == '') {
              self.$refs.buyerInfoRef.openModal()
        }
        else {
          self.handleMessageSentSL()
        }

      },

      handleBIOnClose(name, phone, state){
        var self = this
        if (name.trim() == '' || phone.trim() == '' ){
          self.addMessage({messageClass: 'warning', message: 'Missing Buyer Information!',})
            return
        }
        else {
          this.setBuyer({name: name, phone: phone, stateSel: state})
          self.handleMessageSentSL()
        }
      },

      // Send message from customer
      async handleMessageSentSL() {
        var self = this

        const authToken = await anonSignIn()
        if (!authToken){
          self.addMessage({messageClass: 'error', message: "Invalid User",})
          return
        }

        //const nToken = await getNotificationToken()
        const nToken = await getNotificationToken()

        const postJson = {
          'orgId': self.orgId,
          'text': self.currentMessage,
          'nToken': nToken,
          'buyerName': self.buyer.name,
          'buyerPhone': self.buyer.phone
        }

        axios({
          method: 'POST',
          baseURL: process.env.VUE_APP_ROOT_API,
          url: '/AddMessageFromUser/',
          data: postJson,
          headers: {
            'Authorization': 'Bearer ' + authToken,
            'OrgId': self.orgId,
            'Content-Type': 'application/json',
          },
        })
        .then(async function (response) {
          if (response.data.err != ''){
            self.addMessage({messageClass: 'warning', message: response.data.err,})
          }
        })
        .catch(function (error) {
          self.addMessage({messageClass: 'danger', message: String(error),})
        })

      },

  }
}
</script>

<style>
.loadingItem {
  align-items: center;
  justify-content: center;
  display: flex;
}

.action-panel {
  margin-bottom: 10px;
  margin-right: 5px;
}
</style>
